<template lang="pug">
div
  .my-4(v-for="(document, documentIndex) in getDocuments" :key="`document-${documentIndex}`")
    .text-sm.font-medium {{ documentIndex+1 }}. {{ document.name }}
  .d-flex.justify-end.mt-4
    v-btn.button-sm(color="primary" depressed :disabled="isDisabled" @click="$emit('viewDetails')") {{ $t('view_details') }}
    //- v-btn.button-sm(color="primary" depressed disabled) {{ $t('view_details') }}
</template>

<script>
export default {
  props: {
    parentHistory: {
      type: Object,
      required: true
    },
  },
  computed: {
    isDisabled() {
      return this.getDocuments.length === 0
    },
    getDocuments() {
      return this.parentHistory?.documents ?? []
    },
  },
}
</script>

<style lang="scss" scoped>
</style>